/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Jobs_Card_Slots_LabelInputs */

const en_company_jobs_card_slots_label = /** @type {(inputs: Company_Jobs_Card_Slots_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slots:`)
};

const de_company_jobs_card_slots_label = /** @type {(inputs: Company_Jobs_Card_Slots_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plätze:`)
};

/**
* | output |
* | --- |
* | "Slots:" |
*
* @param {Company_Jobs_Card_Slots_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_jobs_card_slots_label = /** @type {((inputs?: Company_Jobs_Card_Slots_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Jobs_Card_Slots_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_jobs_card_slots_label(inputs)
	return en_company_jobs_card_slots_label(inputs)
});